<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch00_fm04_cont"></a><a id="page_5"></a><strong>Contents</strong></h2>
<p class="toc"><span class="nounder" href="#/xhtml/ch00_fm05_for#ch00_fm05_for" title="Link target outside of Sample">FOREWORD</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample">NEWS FROM CAMP</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">BUT I’M OK NOW</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">CAN YOU GET A REFUND?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">THIS IS AN EMERGENCY, I NEED…</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">HAPPY CAMPERS</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">SIBS, PETS &amp; MISCELLANEOUS MISSIVES</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">P.S.</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">P.P.S. THANK YOU</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_cont.vue?79afd3b8